import {ICamera} from "../../../kova/slsordClient";
import styled from "@emotion/styled/macro";
import {VscButton, VscFlexRow, VscFlexRowLayout} from "../../content/ButtonComponent";

import {IViewCamera, IViewItemConfig} from "../../../data/IViewpoint";


const VideoIcon: React.FC = (props) => {
return (<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" width="59" height="59" rx="29.5" fill="var(--icon-primary)"/>
    <path d="M24.417 19.2917V39.7084L40.4587 29.5L24.417 19.2917Z" fill="var(--icon-fill)"/>
</svg>);
}

const CameraIcon: React.FC = (props) => {
    return (<svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.833008" width="59" height="59" rx="29.5" fill="var(--icon-primary)"/>
            <path d="M30.3334 34.1665C32.9107 34.1665 35.0001 32.0771 35.0001 29.4998C35.0001 26.9225 32.9107 24.8331 30.3334 24.8331C27.7561 24.8331 25.6667 26.9225 25.6667 29.4998C25.6667 32.0771 27.7561 34.1665 30.3334 34.1665Z" fill="var(--icon-fill)"/>
            <path d="M25.9583 14.9167L23.2896 17.8334H18.6667C17.0625 17.8334 15.75 19.1459 15.75 20.7501V38.2501C15.75 39.8542 17.0625 41.1667 18.6667 41.1667H42C43.6042 41.1667 44.9167 39.8542 44.9167 38.2501V20.7501C44.9167 19.1459 43.6042 17.8334 42 17.8334H37.3771L34.7083 14.9167H25.9583ZM30.3333 36.7917C26.3083 36.7917 23.0417 33.5251 23.0417 29.5001C23.0417 25.4751 26.3083 22.2084 30.3333 22.2084C34.3583 22.2084 37.625 25.4751 37.625 29.5001C37.625 33.5251 34.3583 36.7917 30.3333 36.7917Z" fill="var(--icon-fill)"/>
        </svg>

    );
}

const CameraCss = styled.div`
  --icon-primary: var(--primary-color);
  --icon-fill: var(--content-background);
.active {
  --icon-primary: var(--content-background);
  --icon-fill: var(--primary-color);
}
`

export const CameraCard: React.FC<{camera: IViewItemConfig, isActive: boolean, onClick: () => void}> = (props) => {
    const { camera, isActive, onClick } = props;

    return <CameraCss><VscButton className={isActive ? "active" : ""} onClick={onClick}>
        { camera.type === "camera" && <CameraIcon /> }
        { camera.type === "video" && <VideoIcon /> }
        <h4 className={"primary"}>{camera.name}</h4>
        <p>{camera.description ?? ""}</p>


    </VscButton></CameraCss>
}

const CameraCardsDiv = styled.div`
display:flex;
  flex-direction: column;
  gap:32px;
  flex-grow:0;
  ${VscButton} {
    height: 200px;
    width: 200px;
  }
  
`
export const CameraCards: React.FC<{cameras: IViewItemConfig[], activeCamera: string, onSetCamera: (camera:IViewItemConfig) => void}> = (props) => {
    const { cameras, activeCamera, onSetCamera } = props;

    const cameraPairs: [IViewItemConfig, IViewItemConfig?][] = [];
    for (let i = 0; i < cameras.length / 2; ++i) {
        cameraPairs.push([cameras[2*i], cameras[2*i+1]]);
    }


    return <CameraCardsDiv>
        { cameraPairs.map(cp => <VscFlexRow>
            <CameraCard camera={cp[0]} isActive={cp[0]?.name === activeCamera} onClick={() => onSetCamera(cp[0])}/>
                { cp[1] && <CameraCard camera={cp[1]} isActive={cp[1]?.name === activeCamera} onClick={() => onSetCamera(cp[1]!)}/>}
            </VscFlexRow>) }
    </CameraCardsDiv>;
}